/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Edit_DescriptionInputs */



/**
* | output |
* | --- |
* | "Update the server configuration. Changing URL or transport will reset the connection." |
*
* @param {Mcp_Servers_Edit_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_edit_description = /** @type {((inputs?: Mcp_Servers_Edit_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Edit_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Serverkonfiguration aktualisieren. Änderungen an URL oder Transport setzen die Verbindung zurück.")
	return /** @type {LocalizedString} */ ("Update the server configuration. Changing URL or transport will reset the connection.")
});